/* PACKAGES */
import { motion } from "framer-motion";

/* ANIMATION */
import { animation } from "config";

/* MATERIAL TAILWIND COMPONENTS */
import { Button } from "@material-tailwind/react";

/* DATA */
import pricingPlans from "data/websiteDB";

/* ICONS */
import { IoCheckmarkDoneCircle } from "react-icons/io5";

const Plans = () => {
  return (
    <motion.div variants={animation} className="py-5 xl:py-14 lg:py-14">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 gap-5 xl:gap-10 lg:gap-10">
          {pricingPlans.map((plan, index) => (
            <div className="col-span-1" key={index}>
              <div
                className={`${
                  plan.name === "🏛️ Engage Plan"
                    ? "bg-logo bg-opacity-10 border border-logo border-opacity-60"
                    : "bg-white border border-greyBorder"
                } rounded-2xl px-5 xl:px-10 lg:px-10 py-5 xl:py-8 lg:py-8 shadow-md h-full`}
              >
                {/* TOP SECTION */}
                <div
                  className={`border-b ${
                    plan.name === "🏛️ Engage Plan"
                      ? "border-logo border-opacity-40"
                      : "border-greyBorder"
                  } pb-5`}
                >
                  <h5 className="text-xl font-roundo font-bold text-black">
                    {plan.name}
                  </h5>
                  <p className="mt-2 text-base font-source font-normal text-greyText">
                    {plan.description}
                  </p>
                  <a
                    href="https://calendly.com/roundtechsquare/new-meeting"
                    target="_blank"
                    rel="noreferrer"
                    className="mt-5 block"
                  >
                    <Button className="shadow-none normal-case hover:shadow-none bg-logo hover:bg-logo/80 transition-all duration-300 ease-in-out rounded-md px-5 py-2.5 text-base font-source font-medium text-white">
                      Schedule a demo
                    </Button>
                  </a>
                </div>

                {/* BOTTOM SECTION */}
                <div className="py-8 h-full">
                  <h5 className="text-md font-source font-semibold text-black">
                    {plan.name === "🎓 Starter Plan" &&
                      "Features included in this plan:"}
                    {plan.name === "🏛️ Engage Plan" &&
                      "Includes all features from Starter Plan, plus:"}
                    {plan.name === "🌐 Legacy Plan" &&
                      "Includes all features from Engage Plan, plus:"}
                  </h5>

                  {plan.features.map((data, index) => (
                    <div key={index} className="first:mt-0 mt-6">
                      <div className="flex items-start gap-3">
                        <IoCheckmarkDoneCircle className="mt-1 w-5 h-5 text-green-400 flex-shrink-0" />
                        <div className="p-0">
                          <h5 className="text-md font-source font-medium text-black">
                            {data.title}
                          </h5>
                          <p className="mt-1 text-base font-source font-normal text-greyText">
                            {data.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default Plans;
